import { ICustomerBalance } from '../_types';
import { request } from './http-client';

interface ILoginConfirm {
  created_at: string;
  date_of_birth: string;
  id: string;
  name: string;
  phone: string;
}

interface IGooglePhonePayload {
  phone: string;
  tag?: string;
}

interface IGPConfirmPayload {
  phone_number: string;
  otp: string;
}

interface ICustomerAddressPayload {
  address: string;
  apartment?: string;
  building?: string;
  customer_id: string;
  description?: string;
  floor?: string;
  location: {
    lat: number;
    long: number;
  };
  name: string;
}

const customerService = {
  getUserByPhone: (data: any, shipper_id: string) => request.post('/v1/customers/phone', data, {
    headers: {
      Shipper: shipper_id,
    },
  }),
  loginConfirm: (data: any, shipper_id: string, platform_id?: string) =>
    request.post<ILoginConfirm>('/v1/customers/confirm-login', data, {
      headers: {
        Platform: platform_id,
        Shipper: shipper_id,
      },
    }),
  create: (data: any, platform_id?: string) =>
    request.post('/v1/customers', data, {
      headers: {
        Platform: platform_id,
      },
    }),
  registerConfirm: (data: any, shipper_id: string, platform_id?: string) =>
    request.post('/v1/customers/register-confirm', data, {
      headers: {
        Platform: platform_id,
        Shipper: shipper_id,
      },
    }),
  register: (data: any, shipper_id: string, platform_id?: string) => request.post('/v1/customers/register', data, {
    headers: {
      Platform: platform_id,
      Shipper: shipper_id,
    },
  }),
  login: (data: any, shipper_id: string, platform_id?: string) => request.post('/v1/customers/login', data, {
    headers: {
      Platform: platform_id,
      Shipper: shipper_id,
    },
  }),
  deleteProfile: (id: string) =>
    request.delete(`/v2/customers/self-delete/${id}`),
  getCustomerAddresses: (phone: string) =>
    request.get(`/v2/customer-addresses/mika/${phone}`),
  createCustomerAddress: (payload: ICustomerAddressPayload) =>
    request.post('/v1/customer_address', payload),
  updateCustomerAddress: (
    addressId: string | number,
    payload: ICustomerAddressPayload
  ) => request.put(`/v1/customer_address/${addressId}`, payload),
  deleteCustomerAddress: (customerAddressId: string | number) =>
    request.delete(`/v1/customer_address/${customerAddressId}`),
  loginWithoutOTP: (data: any, shipper_id: string | undefined, platform_id: string) =>
    request.post('/v2/customers/login-without-otp', data, {
      headers: {
        Platform: platform_id,
        Shipper: shipper_id,
      },
    }),
  registerWithoutOTP: (data: any, shipper_id: string | undefined, platform_id?: string) =>
    request.post('/v2/customers/register-without-otp', data, {
      headers: {
        Platform: platform_id,
        Shipper: shipper_id,
      },
    }),
  update: (id: string, data: any) => request.put('/v1/customers/' + id, data),
  getIikoCustomerInfo: (params: any) =>
    request.post<ICustomerBalance>('/v2/crm/iiko-customer-info', undefined, {
      params,
    }),
  google: {
    setPhone: (data: IGooglePhonePayload) =>
      request.post('/v2/customers/google-auth-phone-set-with-otp', data),
    confirm: (data: IGPConfirmPayload) =>
      request.post(
        '/v2/customers/google-auth-phone-set-with-otp-confirm',
        data
      ),
    setPhoneWithoutOTP: (data: IGooglePhonePayload) =>
      request.post('/v2/customers/google-auth-phone-set-without-otp', data),
  },
};

export default customerService;
